import React, { useEffect, useState } from "react";
import { Col, Row, Card } from "react-bootstrap";
import { InputLabel } from "@mui/material";
import Select from "react-select";
import { useOpsContext } from "../../../ContextsAndProvider/OpsContext";
import { getPractitionerAuthorizedList } from "../../api/Individual";
import { failed } from "../../common/Toastify";
import { useOrgQuery } from "../../../hooks/ReactQueryHooks/useOrgQuery";
import "./OpsDashboard.css";

const OpsOrganizationPractitionerSelector = ({ onSelectionComplete }) => {
  const {
    selectedOrganization,
    setSelectedOrganization,
    selectedPractitioner,
    setSelectedPractitioner,
    setOrganizations,
  } = useOpsContext();

  const [organizationOptions, setOrganizationOptions] = useState([]);
  const [practitionerOptions, setPractitionerOptions] = useState([]);
  const [isLoadingPractitioners, setIsLoadingPractitioners] = useState(false);

  useOrgQuery({
    onSuccess: (data) => {
      const orgOptions = data?.map((org) => ({
        label: org?.name,
        value: org?.id,
      }));
      setOrganizationOptions(orgOptions);
      setOrganizations(data);
    },
    refetchOnWindowFocus: false,
  });

  useEffect(() => {
    if (selectedOrganization) {
      setIsLoadingPractitioners(true);
      getPractitionerAuthorizedList(selectedOrganization, null, null, true)
        .then((res) => {
          if (res.status === true) {
            const practOptions = res?.result
              ?.map((practitioner) => ({
                value: practitioner.id,
                label: capitalizeWords(practitioner.name?.[0]?.text),
                data: practitioner,
              }))
              .sort((a, b) => a.label.localeCompare(b.label));
            setPractitionerOptions(practOptions);
          }
        })
        .catch((res) => {
          failed(
            res?.response?.data?.message ||
              res?.response?.data?.error ||
              res.message
          );
        })
        .finally(() => setIsLoadingPractitioners(false));
    }
  }, [selectedOrganization]);

  const capitalizeWords = (str) => {
    return str
      ? str
          .toLowerCase()
          .replace(/(^|\s)\S/g, (firstLetter) => firstLetter.toUpperCase())
      : "";
  };

  const handleOrgChange = (selectedOption) => {
    setSelectedOrganization(selectedOption?.value || null);
    setSelectedPractitioner(null);
    if (onSelectionComplete) {
      onSelectionComplete(false);
    }
  };

  const handlePractitionerChange = (selectedOption) => {
    setSelectedPractitioner(selectedOption);
    if (onSelectionComplete && selectedOption) {
      onSelectionComplete(true);
    }
  };

  const selectedOrgOption = organizationOptions.find(
    (org) => org.value === selectedOrganization
  );

  return (
    <Card className="ops-selector-card" >
      <Card.Body>
        <Row className="align-items-end" style={{ marginBottom: "20px" }}>
          <Col md={6}>
            <InputLabel
              id="organization-label"
              style={{ fontSize: "0.75rem", marginBottom: "10px" }}
            >
              Select Organization <span style={{ color: "red" }}>*</span>
            </InputLabel>
            <Select
              onChange={handleOrgChange}
              name="organization"
              options={organizationOptions}
              className="search-select"
              classNamePrefix="select"
              value={selectedOrgOption}
              isClearable={false}
              isLoading={organizationOptions?.length === 0}
              placeholder="Select Organization..."
            />
          </Col>
          <Col md={6}>
            <InputLabel
              id="practitioner-label"
              style={{ fontSize: "0.75rem", marginBottom: "10px" }}
            >
              Select Practitioner <span style={{ color: "red" }}>*</span>
            </InputLabel>
            <Select
              onChange={handlePractitionerChange}
              name="practitioner"
              options={practitionerOptions}
              className="search-select"
              classNamePrefix="select"
              value={selectedPractitioner}
              isClearable={true}
              isLoading={isLoadingPractitioners}
              isDisabled={!selectedOrganization}
              placeholder="Select Practitioner..."
            />
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default OpsOrganizationPractitionerSelector;
